
















import { Vue, cookies, getCookie, setCookie } from "../../constants/constants";

import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("selected-company", {
  name:'selected-company',
  data() {
    return {
      staticContent,
    };
  },
  mounted() {
    
  },

  computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
   
    user(){
      return this.$root.user
    }
  },
  methods: {
    handleChangeCompany(){
      this.$root.initCompanyModal();
      this.$root.modalToggler('company-modal', 'show');
    },
    handleDismissCompany(){
      this.$root.removeCompanyCookie();
      this.companySelected=null;

    }
   
  }
});
